<template>
  <div class="view" v-if="canEdit" v-cloak>
    <EditCreateTitleBox :label="title" />
    <div class="sm-products-add-edit-container">
      <ProductAddOrEditContent
        :product-data="data"
        @onProductSaved="onProductSaved"
        @onGotoListProduct="gotoList"
      />
    </div>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { canEdit, permissions, permissionTypes } from "@/helpers/Permissions";
import * as actions from "@/helpers/generalActions";
import Forbidden from "@/pages/errors/Forbidden";
import EditCreateTitleBox from "@/components/Common/EditCreateTitleBox.vue";
import ProductAddOrEditContent from "./partials/ProductAddOrEditContent.vue";

export default {
  name: "SMProductsDetails",
  components: {
    Forbidden,
    EditCreateTitleBox,
    ProductAddOrEditContent,
  },
  data() {
    return {
      data: {
        is_editable: true,
        lot_management: 0,
      },
    };
  },
  computed: {
    name() {
      return this.$t("common.products");
    },
    config() {
      return {
        permission: permissions.SM_PRODUCTS,
        permission_type: permissionTypes.access,
        get: this.get,
        create: this.create,
        update: this.update,
        delete: this.delete,
        list_url: "/stock-management/sm-products",
        confirm_delete: true,
      };
    },
    actions() {
      return actions;
    },
    canEdit() {
      return canEdit(this);
    },
    title() {
      return (this.data.uuid ? this.$t("common.edit") : this.$t("common.new")) + " " + this.name;
    },
  },
  methods: {
    ...mapActions({
      get: "smProducts/getSmProduct",
      create: "smProducts/createSmProduct",
      update: "smProducts/updateSmProduct",
      delete: "smProducts/deleteSmProduct",
    }),
    loadData() {
      let vm = this;
      return this.actions.getData(
        this,
        (data) => {},
        (data) => {}
      );
    },
    gotoList() {
      return actions.gotoList(this);
    },
    onProductSaved() {
      const listUrl = this.config.list_url;
      setTimeout(() => {
        this.$router.push({ path: listUrl }).catch(() => {
          window.location.href = listUrl;
        });
      }, 300);
    },
  },
  mounted() {
    this.loadData();
    this.actions.handleParams(this);
  },
  watch: {
    $route: {
      handler: function (newVal) {
        this.actions.handleParams(this);
      },
      deep: true,
    },
    permission: {
      handler: function (newVal) {
        this.permissionModule = newVal;
      },
      deep: true,
    },
    data: {
      handler: (data) => {},
      deep: true,
    },
  },
};
</script>

<style scoped>
.view {
  height: calc(100% - 70px);
}

.sm-products-add-edit-container {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
}
</style>
